var _g, _g2, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle, _circle2, _circle3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptychat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 194,
    viewBox: "0 0 262 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9143_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7273 86.5453C54.7273 77.2067 62.2978 69.6362 71.6364 69.6362H257.636V103.454C257.636 112.793 250.066 120.364 240.727 120.364H71.6364C62.2977 120.364 54.7273 112.793 54.7273 103.454V86.5453Z",
    fill: "#F4F4F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9143_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 137.273H190C199.339 137.273 206.909 144.843 206.909 154.182V171.091C206.909 180.43 199.339 188 190 188H20.9091C11.5704 188 4 180.43 4 171.091V137.273Z",
    fill: "#F4F4F4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9143_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2H190C199.339 2 206.909 9.57046 206.909 18.9091V35.8182C206.909 45.1568 199.339 52.7273 190 52.7273H20.9091C11.5704 52.7273 4 45.1568 4 35.8182V2Z",
    fill: "#F4F4F4"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 71.6365,
    y1: 85.6339,
    x2: 194.227,
    y2: 85.6339,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 153.27,
    x2: 188.591,
    y2: 153.27,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 17.9977,
    x2: 188.591,
    y2: 17.9977,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 71.6365,
    y1: 96.9068,
    x2: 194.227,
    y2: 96.9068,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 164.543,
    x2: 170.273,
    y2: 164.543,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 29.2701,
    x2: 188.591,
    y2: 29.2701,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 71.6365,
    y1: 108.179,
    x2: 194.227,
    y2: 108.179,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 175.816,
    x2: 140.682,
    y2: 175.816,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 40.5431,
    x2: 140.682,
    y2: 40.5431,
    stroke: "#D6D6D6",
    strokeWidth: 1.82304
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225.227,
    cy: 95.0001,
    r: 13.6351,
    fill: "#D6D6D6",
    stroke: "#D6D6D6",
    strokeWidth: 0.911519
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0001,
    cy: 162.636,
    r: 13.6351,
    fill: "#D6D6D6",
    stroke: "#D6D6D6",
    strokeWidth: 0.911519
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0001,
    cy: 27.3639,
    r: 13.6351,
    fill: "#D6D6D6",
    stroke: "#D6D6D6",
    strokeWidth: 0.911519
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9143_9249",
    x: 50.7273,
    y: 67.6362,
    width: 210.909,
    height: 58.7271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9143_9249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9143_9249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9143_9249",
    x: 0,
    y: 135.273,
    width: 210.909,
    height: 58.7271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9143_9249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9143_9249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9143_9249",
    x: 0,
    y: 0,
    width: 210.909,
    height: 58.7271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9143_9249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9143_9249",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptychat);
export default __webpack_public_path__ + "static/media/emptychat.52ee14b712a1f31cd9d18cb22009258b.svg";
export { ForwardRef as ReactComponent };